import React from "react";

const Card = ({
    as: Component = "div",
    children,
    padding = "lg",
    interactive = false,
    className = "",
    header,
    meta,
    actions,
    ...props
}) => {
    const classes = [
        "ui-card",
        padding ? `ui-card--pad-${padding}` : "",
        interactive ? "ui-card--interactive" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <Component className={classes} {...props}>
            {(header || meta || actions) && (
                <div className="ui-card__header">
                    <div>
                        {header && <h3 className="ui-card__heading">{header}</h3>}
                        {meta && <span className="ui-card__meta">{meta}</span>}
                    </div>
                    {actions && <div className="ui-card__actions">{actions}</div>}
                </div>
            )}
            {children}
        </Component>
    );
};

export default Card;

